<template lang="pug">
  v-card
    v-card-title
      | Userflows
      v-spacer
      v-autocomplete(:items='users' item-text='email' item-value='ID' v-model='search' )
    v-data-table(:headers='headers', :items='userflowsFiltered')
      template(v-slot:item.user_id='{ item }')
        span {{getEmailByID(item.user_id)}}
      template(v-slot:item.flow='{ item }')
        span {{item.flow.name}}
      template(v-slot:item.step='{ item }')
        span {{item.step.index}}
      template(v-slot:item.action='{ item }')
        v-btn(color='primary' @click='refreshUserflow(item.ID)') refresh
</template>
<script>
export default {
  data() {
    return {
      users: [],
      userflows: [],
      search: '',
      headers: [
        { text: 'User', value: 'user_id' },
        { text: 'Flow', value: 'flow' },
        { text: 'Status', value: 'status' },
        { text: 'Step', value: 'step' },
        { text: 'Actions', value: 'action' },
      ],
    }
  },
  computed: {
    userflowsFiltered() {
      let ufs = this.userflows
      ufs.sort((a, b) => (a.flow.name > b.flow.name) ? 1 : -1)
      if (this.search) {
        return ufs.filter(uf => uf.user_id == this.search)
      }
      return ufs
    }
  },
  mounted() {
    this.getUsers()
    this.getUserflows()
  },
  methods: {
    refreshUserflow(id) {
      this.axios.get(`/admin/userflow/${id}/refresh`).then(() => this.getUserflows())
    },
    getStepIndex(stepID, flow) {
      if(flow.ID != 0) {
        return flow.steps.filter(s => s.ID == stepID)[0].index
      }
      return "error"
    },
    getEmailByID(id) {
      const users = this.users.filter(u => u.ID == id)
      if (users.length > 0) return users[0].email
      return ''
    },
    getUsers() {
      this.axios.get('/admin/users').then(resp => this.users = resp.data)
    },
    getUserflows() {
      this.axios.get('/admin/userflow').then(resp => this.userflows = resp.data)
    }
  }
}
</script>